
export const getLoggedInUserDetail = JSON.parse(localStorage.getItem("userDetail"));